type EventDetailLike = {
  eventId?: string | number | null;
};

const isExternalTransfer = (transferType?: string | null) =>
  (transferType || "").toLowerCase().includes("external");

const hasEventId = (
  eventDetails: EventDetailLike[] | undefined,
  eventId: string | number,
) =>
  !!eventDetails?.some(
    (event) => String(event.eventId ?? "") === String(eventId),
  );

export const canCadExpire = (data: {
  eventId?: string | number | null;
}) => Number(data.eventId) === 1;

export const canCadRefund = (data: {
  transferType?: string | null;
  isBuying?: number | boolean;
  eventId?: string | number | null;
  eventDetails?: EventDetailLike[];
}) => {
  if (!isExternalTransfer(data.transferType)) return false;
  if (Number(data.isBuying) !== 1) return false;
  if (!hasEventId(data.eventDetails, 5)) return false;
  if (hasEventId(data.eventDetails, 7)) return false;
  const current = Number(data.eventId);
  if ([10, 11, 12].includes(current)) return false;
  return true;
};

export const canCadReinitiate = (data: {
  transferType?: string | null;
  eventId?: string | number | null;
  eventDetails?: EventDetailLike[];
}) => {
  if (!isExternalTransfer(data.transferType)) return false;
  if (Number(data.eventId) !== 13) return false;
  if (!hasEventId(data.eventDetails, 5)) return false;
  if (hasEventId(data.eventDetails, 7)) return false;
  return true;
};

export const canIvyRefund = (data: {
  transferType?: string | null;
  eventId?: string | number | null;
  eventDetails?: EventDetailLike[];
}) => {
  if (!isExternalTransfer(data.transferType)) return false;
  if (Number(data.eventId) !== 14) return false;
  if (!hasEventId(data.eventDetails, 5)) return false;
  if (hasEventId(data.eventDetails, 7)) return false;
  return true;
};

export const canIvyReinitiate = (data: {
  transferType?: string | null;
  eventId?: string | number | null;
  eventDetails?: EventDetailLike[];
}) => {
  if (!isExternalTransfer(data.transferType)) return false;
  if (Number(data.eventId) !== 14) return false;
  if (!hasEventId(data.eventDetails, 5)) return false;
  if (hasEventId(data.eventDetails, 7)) return false;
  return true;
};
